import React from 'react';
import './Todo.css';
import { List, ListItemText ,ListItem, ListItemAvatar, Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import db from './firebase';


function Todo(props) {
    return (
        <List class ="todo_list" >
            <ListItem>
            <ListItemText primary={props.todo.todo} secondary="dev"/>
            <DeleteIcon onClick={event => db.collection('todos').doc(props.todo.id).delete()} > </DeleteIcon>
            </ListItem>
            
                    </List>
    )
}

export default Todo
